import { useState, useEffect } from 'react';

export default function ScrollToTop() {
  const [visible, setVisible] = useState(false);
  const [progress, setProgress] = useState(0);

  useEffect(() => {
    const onScroll = () => {
      const scrollTop = window.scrollY;
      const docHeight = document.documentElement.scrollHeight - window.innerHeight;
      const pct = docHeight > 0 ? (scrollTop / docHeight) * 100 : 0;
      setProgress(pct);
      setVisible(scrollTop > 400);
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  const handleClick = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  const r = 18;
  const circumference = 2 * Math.PI * r;
  const strokeDashoffset = circumference - (progress / 100) * circumference;

  return (
    <button
      onClick={handleClick}
      aria-label="Scroll to top"
      className={`fixed bottom-6 right-3 md:bottom-8 md:right-8 z-50 w-12 h-12 flex items-center justify-center cursor-pointer transition-all duration-300 group ${
        visible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-4 pointer-events-none'
      }`}
    >
      {/* Circular progress ring */}
      <svg
        className="absolute inset-0 w-full h-full -rotate-90"
        viewBox="0 0 48 48"
      >
        {/* Track */}
        <circle
          cx="24"
          cy="24"
          r={r}
          fill="none"
          className="dark:stroke-white/10 stroke-black/10"
          strokeWidth="1.5"
        />
        {/* Progress */}
        <circle
          cx="24"
          cy="24"
          r={r}
          fill="none"
          className="dark:stroke-white/50 stroke-black/40 transition-all duration-100"
          strokeWidth="1.5"
          strokeDasharray={circumference}
          strokeDashoffset={strokeDashoffset}
          strokeLinecap="round"
        />
      </svg>

      {/* Button background */}
      <div className="relative w-9 h-9 dark:bg-[#1a1a1a] bg-white dark:border-white/15 border-black/15 border flex items-center justify-center transition-all duration-200 dark:group-hover:bg-white group-hover:bg-black">
        <i className="ri-arrow-up-line text-sm dark:text-neutral-400 text-neutral-500 dark:group-hover:text-black group-hover:text-white transition-colors duration-200" />
      </div>
    </button>
  );
}
